import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiUrlProvider } from './api-url.provider';
import { Employee} from '../shared/models/employee';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { EmployeeActivityModel } from '../shared/models/employee-activity-model';
import { IRosterEmployeeViewModel } from '../shared/models/roster/roster-employee-view-model';
import { EmployeeBase } from '../shared/models/employee-base';
import { IEmployeeSortNoUpdateModel } from '../shared/models/roster/employee-sortno-update-model';
import { IEmployeeUpdateEntities } from '../shared/models/employee-update-entities';
import { IEmployeeHistory } from '../shared/models/EmployeeHistory';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { }

  getEmployees(activeOnly: boolean): Observable<IApiResult<Employee[]>>{
    const params = new HttpParams().set('activeOnly', activeOnly ? "true" : "false");

    return this.http.get<IApiResult<Employee[]>>(`${this.apiUrlProvider.url}/employee`, {params});
  }

  getSimpleEmployees(): Observable<IApiResult<EmployeeBase[]>>{
    return this.http.get<IApiResult<EmployeeBase[]>>(`${this.apiUrlProvider.url}/employee/simple`);
  }

  // getEmployeesByGroup(groupId: number, activeOnly: boolean): Observable<IApiResult<Employee[]>>{
  //   const params = new HttpParams().set('activeOnly', activeOnly ? "true" : "false");
  //   return this.http.get<IApiResult<Employee[]>>(`${this.apiUrlProvider.url}/employee/${groupId}`, {params});
  // }

  getEmployeeById(employeeId: number): Observable<IApiResult<Employee>>{
    return this.http.get<IApiResult<Employee>>(`${this.apiUrlProvider.url}/employee/${employeeId}`);
  }

  getEntitiesForEmployeeUpdateForm(): Observable<IApiResult<IEmployeeUpdateEntities>>{
    return this.http.get<IApiResult<IEmployeeUpdateEntities>>(`${this.apiUrlProvider.url}/employee/UpdateFormEntities`);
  }

  getProjectResponsibleEngineers(): Observable<IApiResult<Employee[]>>{
    return this.http.get<IApiResult<Employee[]>>(`${this.apiUrlProvider.url}/employee/ProjectResponsibleEngineers`);
  }

  getEmployeeHistory(employeeId: number): Observable<IApiResult<IEmployeeHistory[]>>{
    return this.http.get<IApiResult<IEmployeeHistory[]>>(`${this.apiUrlProvider.url}/employee/${employeeId}/EmployeeHistory`);
  }

  updateEmployee(employee: Employee): Observable<IApiResult<Employee>>{
    return this.http.post<IApiResult<Employee>>(`${this.apiUrlProvider.url}/employee/${employee.id}/update`, employee);
  }

  addEmployee(employee: Employee): Observable<IApiResult<Employee>>{
    return this.http.post<IApiResult<Employee>>(`${this.apiUrlProvider.url}/employee`, employee);
  }

  removeEmployeeFromRoster(employee: IRosterEmployeeViewModel): Observable<IApiResult<Employee>>{
    return this.http.post<IApiResult<Employee>>(`${this.apiUrlProvider.url}/employee/${employee.id}/remove-from-roster`, employee);
  }
  
  addEmployeeToActiveRoster(employee: IRosterEmployeeViewModel): Observable<IApiResult<Employee>>{
    return this.http.post<IApiResult<Employee>>(`${this.apiUrlProvider.url}/employee/${employee.id}/add-to-roster`, employee);
  }
  
  activateEmployee(empActivityModel: EmployeeActivityModel, active: boolean): Observable<IApiResult<string>>{
    let url = `${this.apiUrlProvider.url}/employee/${empActivityModel.employeeId}/${active ? "activate" : "delete"}`

    return this.http.post<IApiResult<string>>(url, empActivityModel);
  }

  updateEmployeeWithPut(employee: Employee): Observable<IApiResult<Employee>>{
    return this.http.put<IApiResult<Employee>>(`${this.apiUrlProvider.url}/employee`, employee);
  }

  deleteEmployeeWithDelete(employeeId: number): Observable<IApiResult<string>>{
    return this.http.delete<IApiResult<string>>(`${this.apiUrlProvider.url}/employee/${employeeId}`);
  }

  updateEmployeeRosterSortNo(empsToUpdate: IEmployeeSortNoUpdateModel[]): Observable<IApiResult<IEmployeeSortNoUpdateModel[]>>{
    return this.http.post<IApiResult<IEmployeeSortNoUpdateModel[]>>(`${this.apiUrlProvider.url}/employee/update-roster-sort-no`, empsToUpdate);
  }

  downloadEmployees(whenDone){
    let url = `${this.apiUrlProvider.url}/Employee/download`;
    
    return this.http.get(url, {responseType: 'blob'})
      .subscribe(res => {
        let objectUrl = window.URL.createObjectURL(res);
        let imageAnchor: HTMLAnchorElement = document.createElement("a");
        imageAnchor.href = objectUrl;
        imageAnchor.target = "_blank";
        imageAnchor.download = `employees.xlsx`;
        imageAnchor.click();
        window.URL.revokeObjectURL(objectUrl);
      }, _ => {}, () => { 
        if (whenDone){
          whenDone();
        }
      });
  }
}

